import React, { Component, Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Modal, Button, Image } from "react-bootstrap";


const MinDistanceModal = (props) => {
    return (
        <React.Fragment>
            <Modal show={true} centered>
                <Modal.Header className="border-0" closeButton>
                    <div className="f16-700">
                        This Location is not in serviceable area
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="f16-400 mt-2 mb-4">
                        <p> Please update the location and try again</p>
                    </div>
                    <div className="mt-4">
                        <div className="row">
                            <div className="col-3"></div>
                            <div className="col-6">
                                <Button
                                    variant="danger"
                                    className="btn-md py-2 mb-2 w-100"
                                    onClick={props.handleCancel}
                                >
                                    Okay
                                </Button>
                            </div>
                            <div className="col-3"></div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};

export default MinDistanceModal;